import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../utils/fetchers";
import { getAdminAccessToken } from "../../utils/auth";
import { Customer } from "../../types/modules/admin/customer.type";

interface UseParams {
  page?: number;
  limit?: number;
  status: string;
  name?: string;
  phone?: string;
  email?: string;
  registrationDateFrom?: string;
  registrationDateTo?: string;
}

export const useCustomersByAdmin = ({
  page = 1,
  limit = 10,
  status,
  name = "",
  phone = "",
  email = "",
  registrationDateFrom = "",
  registrationDateTo = "",
}: UseParams) => {
  const token = getAdminAccessToken();
  const queryParams = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
    status: status,
    name: name,
    phone: phone,
    email: email,
    from: registrationDateFrom,
    to: registrationDateTo,
  });

  console.log({ registrationDateFrom, registrationDateTo });
  return useQuery({
    queryKey: [
      "customers-by-admin",
      page,
      limit,
      status,
      name,
      phone,
      registrationDateFrom,
      registrationDateTo,
    ],
    queryFn: () =>
      fetcher<{ data: Customer[]; total: number; totalPages: number }>(
        `customer/all?${queryParams.toString()}`,
        token
      ),
  });
};

export const useCustomerDetailsByAdmin = (customerId: number) => {
  const token = getAdminAccessToken();
  return useQuery({
    queryKey: ["customer-detalis-by-admin", customerId],
    queryFn: () =>
      fetcher<Customer>(`customer?customerId=${customerId}`, token),
  });
};
